require('./bootstrap');

const files = require.context('./', true, /\.vue$/i);
files.keys().map(key => {
    if (!key.includes('/components/game/days/')) {
        Vue.component(key.split('/').pop().split('.')[0], files(key).default);
    }
});

/**
 * Vuex store for game
 */
import store from './plugins/store/store.js';

/**
 * Vue router for game routes
 */
import router from './plugins/router/router.js';

new Vue({ // eslint-disable-line no-new
    el: '#app',
    router,
    store,
    data: {
        form: {
            login: {
                email: '',
                password: ''
            },
            email: {
                email: ''
            },
            register: {
                password: '',
                passwordConfirm: '',
                whereAdvertise: ''
            },
            reset: {
                email: '',
                password: '',
                passwordConfirm: ''
            }
        }
    }
});
